<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="text-center">
            <h5>
              Deduplicate {{ campaignDescription["campaign_name"] }} Contact Data
            </h5>

            <p class="mt-5">
              These are the list of new and old matched campaign contacts. Upper is the old
              contacts for campaign and below are the newcontacts Please click
              accept to make changes or ignore to do nothing.
            </p>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="completedDeduplicate">Finished</vs-button>
        </vs-col>
      </vs-row>


      <template v-for="(matched_contact, key) in match_contacts">

        
        <vs-table stripe :key="key" :data="matched_contact" class="mt-10">
          <template slot="thead">
            <vs-th>Company</vs-th>
          

             <vs-th
              >Forename</vs-th
            >

            <vs-th
              >Surname</vs-th
            >
            

            <vs-th>
              Action
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              v-for="(duplicate_matched_contact, index) in matched_contact"
            >
              <vs-td>
                {{ duplicate_matched_contact.company_name }}
              </vs-td>
            

             <vs-td
              >
                {{ duplicate_matched_contact.forename }}
              </vs-td>
              <vs-td
              >
                {{ duplicate_matched_contact.surname }}
              </vs-td>
             

              <vs-td>
                <template v-if="index === 1">
                  <vs-button @click="acceptToUpdate(duplicate_matched_contact)"
                    >Accept</vs-button
                  >
                </template>

                <template v-if="index === 0">
                  <vs-button
                    @click="IgnoreUpdateToMasterDB(duplicate_matched_contact)"
                    >Ignore</vs-button
                  >
                </template>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
    <vs-popup
      fullscreen
      style="z-index: 999999;"
      class="holamundo"
      title="Enrich New Csv Data To Old Csv"
      :active.sync="enrichContactDataToMasterDBPopUp"
    >
      <div class="text-center">
        <h6 class="mb-2">
          <!-- Contact : {{ contactDataDescription.company_name }} -->
        </h6>
        <p>
          These are the list of contacts from old csv and contacts from new csv.
          Please click on checkbox and submit in order to add in old csv.
        </p>
      </div>

      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> New Uploaded CSV </u></h6>
            </div>
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Old Uploaded CSV</u></h6>
            </div>
          </div>
        </vs-col>
      

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].title !=
              contactDataDescriptions[1].title
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>title :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.title != null &&
                      contactDataDescriptions[0].title !=
                        contactDataDescriptions[1].title
                  "
                  v-model="contacts.title"
                  :vs-value="contactDataDescription.title"
                  class="mr-4"
                  vs-name="title"
                  >{{ contactDataDescription.title }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.title == null
                      ? "EMPTY"
                      : contactDataDescription.title
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.title == null
                      ? "EMPTY"
                      : contactDataDescription.title
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].forename !=
              contactDataDescriptions[1].forename
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>forename :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.forename !=
                      null &&
                      contactDataDescriptions[0].forename !=
                        contactDataDescriptions[1].forename
                  "
                  v-model="contacts.forename"
                  :vs-value="contactDataDescription.forename"
                  class="mr-4"
                  vs-name="forename"
                  >{{ contactDataDescription.forename }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.forename == null
                      ? "EMPTY"
                      : contactDataDescription.forename
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.forename == null
                      ? "EMPTY"
                      : contactDataDescription.forename
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>
        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].surname !=
              contactDataDescriptions[1].surname
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>surname :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.surname !=
                      null &&
                      contactDataDescriptions[0].surname !=
                        contactDataDescriptions[1].surname
                  "
                  v-model="contacts.surname"
                  :vs-value="contactDataDescription.surname"
                  class="mr-4"
                  vs-name="surname"
                  >{{ contactDataDescription.surname }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.surname == null
                      ? "EMPTY"
                      : contactDataDescription.surname
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.surname == null
                      ? "EMPTY"
                      : contactDataDescription.surname
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].job_title !=
              contactDataDescriptions[1].job_title
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>job_title :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.job_title !=
                      null &&
                      contactDataDescriptions[0].job_title !=
                        contactDataDescriptions[1].job_title
                  "
                  v-model="contacts.job_title"
                  :vs-value="contactDataDescription.job_title"
                  class="mr-4"
                  vs-name="job_title"
                  >{{ contactDataDescription.job_title }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.job_title == null
                      ? "EMPTY"
                      : contactDataDescription.job_title
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.job_title == null
                      ? "EMPTY"
                      : contactDataDescription.job_title
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].ddi !=
              contactDataDescriptions[1].ddi
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>ddi :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.ddi !=
                      null &&
                      contactDataDescriptions[0].ddi !=
                        contactDataDescriptions[1].ddi
                  "
                  v-model="contacts.ddi"
                  :vs-value="contactDataDescription.ddi"
                  class="mr-4"
                  vs-name="ddi"
                  >{{ contactDataDescription.ddi }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.ddi == null
                      ? "EMPTY"
                      : contactDataDescription.ddi
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.ddi == null
                      ? "EMPTY"
                      : contactDataDescription.ddi
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].mobile !=
              contactDataDescriptions[1].mobile
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>mobile :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.mobile != null &&
                      contactDataDescriptions[0].mobile !=
                        contactDataDescriptions[1].mobile
                  "
                  v-model="contacts.mobile"
                  :vs-value="contactDataDescription.mobile"
                  class="mr-4"
                  vs-name="mobile"
                  >{{ contactDataDescription.mobile }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.mobile == null
                      ? "EMPTY"
                      : contactDataDescription.mobile
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.mobile == null
                      ? "EMPTY"
                      : contactDataDescription.mobile
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].seniority !=
              contactDataDescriptions[1].seniority
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>seniority :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.seniority != null &&
                      contactDataDescriptions[0].seniority !=
                        contactDataDescriptions[1].seniority
                  "
                  v-model="contacts.seniority"
                  :vs-value="contactDataDescription.seniority"
                  class="mr-4"
                  vs-name="seniority"
                  >{{ contactDataDescription.seniority }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.seniority == null
                      ? "EMPTY"
                      : contactDataDescription.seniority
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.seniority == null
                      ? "EMPTY"
                      : contactDataDescription.seniority
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].social_media !=
              contactDataDescriptions[1].social_media
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>social_media :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.social_media != null &&
                      contactDataDescriptions[0].social_media !=
                        contactDataDescriptions[1].social_media
                  "
                  v-model="contacts.social_media"
                  :vs-value="contactDataDescription.social_media"
                  class="mr-4"
                  vs-name="social_media"
                  >{{ contactDataDescription.social_media }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.social_media == null
                      ? "EMPTY"
                      : contactDataDescription.social_media
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.social_media == null
                      ? "EMPTY"
                      : contactDataDescription.social_media
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].role !=
              contactDataDescriptions[1].role
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>role :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.role != null &&
                      contactDataDescriptions[0].role !=
                        contactDataDescriptions[1].role
                  "
                  v-model="contacts.role"
                  :vs-value="contactDataDescription.role"
                  class="mr-4"
                  vs-name="role"
                  >{{ contactDataDescription.role }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.role == null
                      ? "EMPTY"
                      : contactDataDescription.role
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.role == null
                      ? "EMPTY"
                      : contactDataDescription.role
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col 
          v-for="(contactDataDescription, index) in contactDataDescriptions"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <div
            class="vx-row mb-6"
            v-bind:class="[
              contactDataDescriptions[0].sub_role !=
              contactDataDescriptions[1].sub_role
                ? 'bg-grey-gradient pt-5 pb-5 text-dark'
                : ''
            ]"
          >
            <div class="vx-col sm:w-1/3 w-full">
              <span>sub_role :</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <template v-if="index == 0">
                <vs-radio
                  v-if="
                    contactDataDescription.sub_role != null &&
                      contactDataDescriptions[0].sub_role !=
                        contactDataDescriptions[1].sub_role
                  "
                  v-model="contacts.sub_role"
                  :vs-value="contactDataDescription.sub_role"
                  class="mr-4"
                  vs-name="sub_role"
                  >{{ contactDataDescription.sub_role }}
                </vs-radio>

                <span v-else>
                  {{
                    contactDataDescription.sub_role == null
                      ? "EMPTY"
                      : contactDataDescription.sub_role
                  }}
                </span>
              </template>

              <template v-if="index == 1">
                <span>
                  {{
                    contactDataDescription.sub_role == null
                      ? "EMPTY"
                      : contactDataDescription.sub_role
                  }}
                </span>
              </template>
            </div>
          </div>
          <vs-divider class="p-5" />
        </vs-col>

        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <div class="text-center">
            <vs-button @click.prevent="submitForm">Submit</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import vSelect from "vue-select";
import _ from "lodash";
export default {
  data: () => ({
    match_contacts: [],
    contacts: {
      company_name: null,
      surname: null,
      job_title: null,
      ddi: null,
      mobile: null,
      seniority: null,
      social_media: null,
      role: null,
      sub_role: null,
    },
    contactDataDescriptions: {},
    enrichContactDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: {},
    enrichContactDataToMasterDB: []
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  methods: {
    submitForm() {

       console.log("OLD" , this.contactDataDescriptions[1].ml_id)
       console.log("NEW" , this.contactDataDescriptions[0].ml_id)
      //  return false


      this.contacts.old_csv_ml_id = this.contactDataDescriptions[1].ml_id;
      this.contacts.new_csv_ml_id = this.contactDataDescriptions[0].ml_id;
      this.contacts.campaignId = this.campaignId;

      let self = this;
      this.$store
        .dispatch("contactsManagement/updateOldCsvContactData", this.contacts)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "CSV Updated",
              text: "The csv contact was update successfully."
            });
            self.enrichContactDataToMasterDBPopUp = false;
            self.router.go(0)
            // this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })

      // alert("ASdadasd");
    },
    completedDeduplicate() {
      this.$router
        .push("/contacts/enrichContactDataToMasterDb/" + this.campaignId)
        .catch(() => {});
    },
    acceptToUpdate(data) {
      this.contactDataDescriptions = this.match_contacts[data["accepted"]];

      // console.log(data);

      this.contacts = {
            company_name: null,
        surname: null,
        job_title: null,
        ddi: null,
        mobile: null,
        seniority: null,
        social_media: null,
        role: null,
        sub_role: null,
      };
      this.enrichContactDataToMasterDBPopUp = true;
    },
    IgnoreUpdateToMasterDB(data) {
      this.contacts.new_csv_ml_id = data.ml_id;
      this.contacts.campaignId = this.campaignId;
      let self = this;

      this.$store
        .dispatch("contactsManagement/ignoreCsvContactNewData", this.contacts)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Contact Ignored",
              text: "This csv contact has been ignored."
            });
            this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    goBack: function() {
      this.$router.go(-1);

    },
    formatUploadedHeader(s) {
      if (typeof s  !== "string") return "";
      if (s.startsWith("ml_")) return "";
      if (s === "master_db_contact") return "";
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s;
    },
          getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    matchedData() {
      let data = {};
      data.campaignId = this.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/deduplicate_csv_contacts_data",
          data
        )
        .then(response => {
          this.match_contacts = JSON.parse(response.data);
          // this.match_contacts.forEach(function(ele) {
          //   if (ele.no_of_employees != null) {
          //     ele.no_of_employees = parseInt(ele.no_of_employees);
          //   }

          //   if (ele.revenue != null) {
          //     ele.revenue = parseInt(ele.revenue);
          //   }
          //   return ele;
          // });

          if (this.match_contacts.length == 0) {
            this.$vs.notify({
              color: "success",
              title: "Duplicate Contacts",
              text: "There are no duplicate contacts on csv. You may enrich campaign contact data to master database"
            });
            this.$router
              .push(
                "/contacts/optionsAfterImportContactToCampaign/" +
                  this.campaignId
              )
              .catch(() => {});
          } else {
            this.match_contacts = _.groupBy(this.match_contacts, "accepted");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
            this.getCampaignDescription()

    this.matchedData();
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;

    // this.getAssocaitedContactsContacts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
